import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl + '/tradeReport'
export default {
    list(params) {
        return request({
            url: BASE_URL + '/list',
            method: 'get',
            params
        })
    },
    exportExcel(params) {
        return request({
            url: BASE_URL + '/exportExcel',
            method: 'get',
            responseType: 'blob',
            params
        })
    },
}